import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=57904a1c"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57904a1c')) {
      api.createRecord('57904a1c', component.options)
    } else {
      api.reload('57904a1c', component.options)
    }
    module.hot.accept("./anchor.vue?vue&type=template&id=57904a1c", function () {
      api.rerender('57904a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/anchor.vue"
export default component.exports